import React from 'react';
import Button from '../Button';

// Same as home Hero overlay so bg image is visible in the back ($primaryDark / $bodyBg)
const HERO_STYLE_OVERLAY = 'linear-gradient(135deg, rgba(3, 16, 30, 0.92) 0%, rgba(10, 15, 26, 0.85) 100%)';

export default function Cta({ title, subTitle, bgUrl, btnUrl, btnText }) {
  return (
    <div className="container">
      <div
        className="cs_cta cs_style_1 cs_bg_filed cs_radius_20"
        style={{
          backgroundImage: bgUrl ? `${HERO_STYLE_OVERLAY}, url(${bgUrl})` : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
        }}
      >
        <h2 className="cs_cta_title cs_fs_72">{title}</h2>
        <p className="cs_cta_subtitle cs_heading_color">{subTitle}</p>
        <Button btnUrl={btnUrl} btnText={btnText} />
      </div>
    </div>
  );
}
